export default __webpack_public_path__ + "static/media/ic_rights.11d4c40b.svg";